<template>
  <div class="mainDiv">
    <div class="content">
      <h1>OneKey</h1>
    </div>
  </div>

</template>

<script>
    export default {
        name: "OneKey"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OneKey.vue